/* global common */
import { sendAmplitudeEvent } from '@html/_common/utils';

export default function AOPaxTravelersMenu(persistSelection) {
  this.common = {};
  if (typeof sendAmplitudeEvent !== 'undefined') {
    this.common = {
      sendAmplitudeEvent,
    };
  } else {
    this.common = common;
  }
  this.persistSelection = persistSelection;

  const SELECTOR_PAX_TRAVELERS_MENU = '.js-ao-pax-travelers-menu';
  const SELECTOR_PAX_ADULTS_ADD = '.js-ao-pax-travelers-menu__controls-adults-add';
  const SELECTOR_PAX_ADULTS_SUBTRACT = '.js-ao-pax-travelers-menu__controls-adults-subtract';
  const SELECTOR_PAX_CHILDREN_ADD = '.js-ao-pax-travelers-menu__controls-children-add';
  const SELECTOR_PAX_CHILDREN_SUBTRACT = '.js-ao-pax-travelers-menu__controls-children-subtract';
  const SELECTOR_PAX_ADULTS_NUMBER = '.js-ao-pax-travelers-menu__adults-number';
  const SELECTOR_PAX_CHILDREN_NUMBER = '.js-ao-pax-travelers-menu__children-number';
  const SELECTOR_PAX_TRAVELERS_MENU_CTA = '.js-ao-pax-travelers-menu__cta-button';

  const applyTravelersChanges = (e) => {
    const $adultsValue = $(SELECTOR_PAX_ADULTS_NUMBER).eq(0);
    const numberOfAdults = parseInt($adultsValue.text().trim(), 10);
    const $childrenValue = $(SELECTOR_PAX_CHILDREN_NUMBER).eq(0);
    const numberOfChildren = parseInt($childrenValue.text(), 10);

    // Cache data attributes before triggering event to avoid repeated DOM queries
    const $closestTravelers = $(e.target).closest('.js-ao-pax-travelers');
    const dataPlacement = $closestTravelers.attr('data-placement') || $('.js-ao-pax-travelers-sheet').attr('data-placement');
    const eventName = $closestTravelers.attr('data-event-name') || $('.js-ao-pax-travelers-sheet').attr('data-event-name');

    // Trigger event immediately so UI can update with fresh data
    $(document).trigger('paxSelection:travelersChange', { numberOfAdults, numberOfChildren });

    // Defer I/O and analytics to idle time to improve INP
    if (this.persistSelection || eventName) {
      setTimeout(() => {
        if (this.persistSelection) {
          document.cookie = `pax_number_of_adults=${numberOfAdults}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
          document.cookie = `pax_number_of_children=${numberOfChildren}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
        }
        if (eventName) {
          this.common.sendAmplitudeEvent({
            ampEventName: eventName,
            adult_pax_count: numberOfAdults,
            child_pax_count: numberOfChildren,
            click_source: dataPlacement,
          });
        }
      }, 0);
    }
  };

  const addAdults = (e) => {
    const $adultsNumber = $(SELECTOR_PAX_ADULTS_NUMBER).eq(0);
    const currentValue = parseInt($adultsNumber.text().trim(), 10);
    const newValue = currentValue + 1;
    $(SELECTOR_PAX_ADULTS_NUMBER).empty().text(newValue);
    if (newValue > 1 && $(SELECTOR_PAX_ADULTS_SUBTRACT).prop('disabled')) {
      $(SELECTOR_PAX_ADULTS_SUBTRACT).prop('disabled', false);
    }
    if ($(e.target).closest(SELECTOR_PAX_TRAVELERS_MENU).attr('data-hide-cta')) {
      applyTravelersChanges(e);
    }
  };

  const subtractAdults = (e) => {
    const $adultsNumber = $(SELECTOR_PAX_ADULTS_NUMBER).eq(0);
    const currentValue = parseInt($adultsNumber.text(), 10);
    if (currentValue > 1) {
      const newValue = currentValue - 1;
      $(SELECTOR_PAX_ADULTS_NUMBER).empty().text(newValue);
      if (newValue === 1) {
        $(SELECTOR_PAX_ADULTS_SUBTRACT).prop('disabled', true);
      }
    }
    if ($(e.target).closest(SELECTOR_PAX_TRAVELERS_MENU).attr('data-hide-cta')) {
      applyTravelersChanges(e);
    }
  };

  const addChildren = (e) => {
    const $childrenNumber = $(SELECTOR_PAX_CHILDREN_NUMBER).eq(0);
    const currentValue = parseInt($childrenNumber.text(), 10);
    const newValue = currentValue + 1;
    $(SELECTOR_PAX_CHILDREN_NUMBER).empty().text(newValue);
    if (newValue > 0 && $(SELECTOR_PAX_CHILDREN_SUBTRACT).prop('disabled')) {
      $(SELECTOR_PAX_CHILDREN_SUBTRACT).prop('disabled', false);
    }
    if ($(e.target).closest(SELECTOR_PAX_TRAVELERS_MENU).attr('data-hide-cta')) {
      applyTravelersChanges(e);
    }
  };

  const subtractChildren = (e) => {
    const $childrenNumber = $(SELECTOR_PAX_CHILDREN_NUMBER).eq(0);
    const currentValue = parseInt($childrenNumber.text(), 10);
    if (currentValue > 0) {
      const newValue = currentValue - 1;
      $(SELECTOR_PAX_CHILDREN_NUMBER).empty().text(newValue);
      if (newValue === 0) {
        $(SELECTOR_PAX_CHILDREN_SUBTRACT).prop('disabled', true);
      }
    }
    if ($(e.target).closest(SELECTOR_PAX_TRAVELERS_MENU).attr('data-hide-cta')) {
      applyTravelersChanges(e);
    }
  };
  const checkPaxCookies = () => {
    const adultsCookie = document.cookie.split('; ').find((row) => row.startsWith('pax_number_of_adults='));
    const childrenCookie = document.cookie.split('; ').find((row) => row.startsWith('pax_number_of_children='));

    const numberOfAdults = adultsCookie && !Number.isNaN(adultsCookie.split('=')[1]) ? parseInt(adultsCookie.split('=')[1], 10) : null;
    const numberOfChildren = childrenCookie && !Number.isNaN(childrenCookie.split('=')[1]) ? parseInt(childrenCookie.split('=')[1], 10) : null;

    const numAdults = numberOfAdults || 2;
    const numChildren = numberOfChildren || 0;

    $(SELECTOR_PAX_ADULTS_NUMBER).empty().text(numAdults);
    if (numAdults === 1) {
      $(SELECTOR_PAX_ADULTS_SUBTRACT).prop('disabled', true);
    }

    $(SELECTOR_PAX_CHILDREN_NUMBER).empty().text(numChildren);
    if (numChildren > 0) {
      $(SELECTOR_PAX_CHILDREN_SUBTRACT).prop('disabled', false);
    }

    $(document).trigger('paxSelection:travelersChange', { numberOfAdults: numAdults, numberOfChildren: numChildren });
  };

  this.initiate = () => {
    checkPaxCookies();
    $(SELECTOR_PAX_ADULTS_ADD).on('click', (event) => addAdults(event));
    $(SELECTOR_PAX_ADULTS_SUBTRACT).on('click', (event) => subtractAdults(event));
    $(SELECTOR_PAX_CHILDREN_ADD).on('click', (event) => addChildren(event));
    $(SELECTOR_PAX_CHILDREN_SUBTRACT).on('click', (event) => subtractChildren(event));
    $(SELECTOR_PAX_TRAVELERS_MENU_CTA).on('click', applyTravelersChanges);
  };
}
